<template>
  <div class="selectors flight-select osago-issue-page">
    <div class="container">
      <!-- Навігація (степпер) -->
      <div class="row">
        <div class="col-12">
          <div class="navsteps navstepts-flight">
            <div class="navsteps__item">
              <div class="number">1</div>
              <div class="descr">Розрахунок</div>
            </div>
            <div class="navsteps__item active">
              <div class="number">2</div>
              <div class="descr">Вибір пропозиції</div>
            </div>
            <div class="navsteps__item">
              <div class="number">3</div>
              <div class="descr">Оформлення</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Параметри пошуку (collapsed form) -->
      <div class="row">
        <div class="col-12">
          <div class="params-search">
            <a class="params-search__toggler collapsed" data-toggle="collapse" data-target="#searchcollapse" aria-expanded="false" aria-controls="#searchcollapse">
              <span>Параметри пошуку</span>
              <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.2795 2.75059e-08L11 0.69496L5.5 6L-2.31891e-07 0.694961L0.7205 4.45343e-07L5.50275 4.61273L10.2795 2.75059e-08Z" fill="black"/>
              </svg>
              <span class="mob">Змінити</span>
            </a>
            <div class="collapse" id="searchcollapse">
              <div class="params-search__content">
                <AccidentSearchForm
                  v-if="searchParams"
                  :data-start-date="searchParams.startDate"
                  :data-period-option="searchParams.period"
                  :data-protection-period="searchParams.protectionPeriod"
                  :data-birth-date="searchParams.birthDate"
                  :data-country="searchParams.country"
                  :data-sum="searchParams.sum"
                  :data-active-factor="searchParams.activeFactor"
                  :data-war-risk="searchParams.warRisk"
                  :data-sport-type="searchParams.sportType"
                  :data-sport-category="searchParams.sportCategory"
                  :data-profession="searchParams.profession"
                  :data-is-sport-group="searchParams.isSportGroup"
                  :data-sport-group="searchParams.sportGroup"
                  :data-accident-risks="searchParams.accidentRisks"
                  @submitSearch="handleSearch"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Результати -->
      <div class="row flex-lg-row-reverse">
        <!-- Права колонка (можливе промо або інфо) -->
        <div class="col-lg-4 osago-results-osago-info-resize">
          <div class="sticky-wrapp">
            <div class="scroll-wrap">
              <AccidentPolicyInfo v-if="!loading && offers.length > 0" />
            </div>
          </div>
        </div>

        <!-- Основний список -->
        <div class="col-lg-8">
          <!-- Лоадер -->
          <div class="col-12 position-relative results" v-if="loading">
            <div class="results_anime">
              <div class="results_anime_circles">
                <div class="waiting_animation">
                  <div class="background">
                    <div class="loader loader-left"></div>
                    <div class="loader loader-right"></div>
                  </div>
                </div>
              </div>
              <div class="results_anime_line">
                <span class="results_anime_line-scale" :style="`width: 100%;`"></span>
              </div>
            </div>
          </div>

          <!-- Повідомлення про відсутність результатів -->
          <div v-else-if="!loading && offers.length === 0" class="no-results mt-5 text-center">
            <h3>На жаль, за вашим запитом нічого не знайдено.</h3>
            <p>Спробуйте змінити параметри пошуку.</p>
          </div>

          <!-- Список пропозицій -->
          <div v-else class="flight-results__top">
            <div class="flight-results__heading">Знайдено: <span>{{ offers.length }}</span></div>

            <!-- Перемикач заробітку -->
            <div v-if="!$store.getters.USER.organizationId" class="osago-offers__earnings accident-earnings">
              <button v-if="!showEarnings" @click="showEarnings = true" type="button">
                 <svg style="margin-bottom: 5px" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0)"><path d="M0.666504 8C0.666504 8 3.33317 2.66667 7.99984 2.66667C12.6665 2.66667 15.3332 8 15.3332 8C15.3332 8 12.6665 13.3333 7.99984 13.3333C3.33317 13.3333 0.666504 8 0.666504 8Z" stroke="#24282C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z" stroke="#24282C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g>
                    <defs><clipPath id="clip0"><rect width="16" height="16" fill="white"/></clipPath></defs>
                 </svg>
                 <span>Показати заробіток</span>
              </button>
              <button v-else @click="showEarnings = false" type="button">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.11649 5.0665C9.4088 5.02169 9.70411 4.9994 9.99983 4.99983C12.6498 4.99983 15.1415 6.90816 16.5915 9.99983C16.3697 10.4703 16.1193 10.9267 15.8415 11.3665C15.7533 11.503 15.707 11.6623 15.7082 11.8248C15.71 12.0067 15.7713 12.183 15.8827 12.3267C15.9941 12.4705 16.1495 12.5739 16.3251 12.6211C16.5008 12.6683 16.687 12.6568 16.8555 12.5882C17.024 12.5197 17.1654 12.3979 17.2582 12.2415C17.6464 11.6314 17.9837 10.9904 18.2665 10.3248C18.3112 10.2208 18.3343 10.1088 18.3343 9.99566C18.3343 9.88248 18.3112 9.77048 18.2665 9.6665C16.5832 5.75816 13.4165 3.33316 9.99983 3.33316C9.60872 3.33119 9.21823 3.36466 8.83316 3.43316C8.72373 3.45177 8.61903 3.49174 8.52504 3.55081C8.43106 3.60988 8.34963 3.68688 8.2854 3.77741C8.22117 3.86795 8.17541 3.97025 8.15072 4.07848C8.12602 4.1867 8.12289 4.29873 8.1415 4.40816C8.1601 4.5176 8.20008 4.6223 8.25914 4.71628C8.31821 4.81027 8.39521 4.8917 8.48575 4.95592C8.57628 5.02015 8.67858 5.06592 8.78681 5.09061C8.89503 5.1153 9.00706 5.11843 9.11649 5.09983V5.0665ZM3.0915 1.90816C3.0138 1.83046 2.92155 1.76883 2.82004 1.72678C2.71852 1.68473 2.60971 1.66309 2.49983 1.66309C2.38995 1.66309 2.28114 1.68473 2.17962 1.72678C2.0781 1.76883 1.98586 1.83046 1.90816 1.90816C1.75124 2.06508 1.66309 2.27791 1.66309 2.49983C1.66309 2.72175 1.75124 2.93458 1.90816 3.0915L4.4915 5.6665C3.31281 6.8011 2.37471 8.16148 1.73316 9.6665C1.68728 9.77163 1.66359 9.88511 1.66359 9.99983C1.66359 10.1145 1.68728 10.228 1.73316 10.3332C3.4165 14.2415 6.58316 16.6665 9.99983 16.6665C11.4974 16.6561 12.9596 16.2102 14.2082 15.3832L16.9082 18.0915C16.9856 18.1696 17.0778 18.2316 17.1793 18.2739C17.2809 18.3162 17.3898 18.338 17.4998 18.338C17.6098 18.338 17.7188 18.3162 17.8203 18.2739C17.9219 18.2316 18.014 18.1696 18.0915 18.0915C18.1696 18.014 18.2316 17.9219 18.2739 17.8203C18.3162 17.7188 18.338 17.6098 18.338 17.4998C18.338 17.3898 18.3162 17.2809 18.2739 17.1793C18.2316 17.0778 18.1696 16.9856 18.0915 16.9082L3.0915 1.90816ZM8.39149 9.56649L10.4332 11.6082C10.2923 11.6486 10.1463 11.6682 9.99983 11.6665C9.5578 11.6665 9.13388 11.4909 8.82132 11.1783C8.50876 10.8658 8.33316 10.4419 8.33316 9.99983C8.33146 9.85332 8.35111 9.70734 8.39149 9.56649ZM9.99983 14.9998C7.34983 14.9998 4.85816 13.0915 3.4165 9.99983C3.9549 8.81129 4.71906 7.73864 5.6665 6.8415L7.1415 8.33316C6.79503 8.96549 6.66295 9.69312 6.76504 10.4069C6.86714 11.1206 7.19793 11.782 7.70777 12.2919C8.21761 12.8017 8.87902 13.1325 9.59278 13.2346C10.3065 13.3367 11.0342 13.2046 11.6665 12.8582L12.9915 14.1665C12.0841 14.7006 11.0527 14.9879 9.99983 14.9998Z" fill="#24282C"/>
                </svg>
                 Сховати заробіток
              </button>
            </div>
          </div>
          <div class="result-list new-list" v-if="offers.length > 0">
            <div class="result-article" v-for="(offer, index) in offers" :key="index">
              <div class="result-article__wrapp">
                <div class="result-item result-item-rated">
                  <div class="result-wrapp">
                    <div class="result__info">
                      <div class="result__logo">
                        <img v-if="offer.company && offer.company.logo" :src="offer.company.logo" alt="logo">
                        <img v-else src="images/aboutUs-insurance_icon.svg" alt="logo">
                      </div>
                      <div class="result__info__main">
                        <div class="result__name">
                          <h5>{{ offer.companyNamePublic || offer.companyName }}</h5>
                        </div>
                        <div class="result__rating" v-if="offer.company && offer.company.rating">
                            <i v-for="stars in 5" :key="stars">
                                <svg v-if="Math.floor(offer.company.rating) >= stars" width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.99984 13.417L14.1665 16.5003L12.8332 10.667L17.3332 6.66699L11.3332 6.16699L8.99984 0.666992L6.6665 6.16699L0.666504 6.66699L5.24984 10.667L3.9165 16.5003L8.99984 13.417Z" fill="#FA9B13"></path>
                                </svg>
                                <svg v-else width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.25607 12.9876L8.99774 12.8335L8.74053 12.9895L4.66713 15.4602L5.73727 10.7784L5.8039 10.4869L5.5786 10.2903L1.88543 7.06715L6.70803 6.66527L7.00889 6.64019L7.12679 6.36227L8.99984 1.94724L10.8729 6.36227L10.9908 6.64019L11.2916 6.66527L16.129 7.06838L12.501 10.2933L12.2798 10.4899L12.3457 10.7784L13.4185 15.4717L9.25607 12.9876Z" stroke="#FA9B13"></path>
                                </svg>
                            </i>
                        </div>
                      </div>
                    </div>
                    <div class="result__details">
                      <div class="result__params">
                        <div class="result__param param-options">
                          <div class="heading">
                            <span>Програма</span> <i
                            data-placement="bottom"
                            data-toggle="tooltip"
                            title=""
                            class="icon question"
                            data-html="true" data-select="true"
                            data-original-title="Програма страхування"></i>

                          </div>
                          <div class="descr">
                            {{ offer.program || 'Стандартний пакет НВ' }}
                          </div>
                        </div>
                      </div>
                      <div class="result__more">
                        <a data-toggle="collapse" :data-target="'#brandMore-'+index" aria-expanded="false" :aria-controls="'brandMore-'+index" class="collapsed">
                          Детальніше про поліс
                          <img src="/img/arrow-down.8bfc342c.svg" alt="Подробнее о полисе">
                        </a>
                      </div>
                    </div>
                    <div class="result__order">
                      <div class="result__netto-price text-muted text-center mb-1" style="font-size: 13px;" v-if="showEarnings && offer.earnings">
                        Нетто-платіж {{ showNetto(offer) }} грн
                      </div>
                      <div class="result__price">
                        <div class="value">{{ offer.price }} <span><svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.000117242 5.39197V4.20797H6.38412C6.53345 4.05863 6.63478 3.90397 6.68812 3.74397C6.75212 3.5733 6.78412 3.38663 6.78412 3.18397C6.78412 2.65063 6.60278 2.2133 6.24012 1.87197C5.87745 1.51997 5.33878 1.34397 4.62412 1.34397C4.00545 1.34397 3.50412 1.5093 3.12012 1.83997C2.74678 2.15997 2.43212 2.61863 2.17612 3.21597L0.656117 3.07197C0.901451 2.12263 1.35478 1.37597 2.01612 0.831966C2.67745 0.2773 3.52012 -3.33786e-05 4.54412 -3.33786e-05C5.30145 -3.33786e-05 5.95212 0.1333 6.49612 0.399966C7.05078 0.655966 7.47745 1.02397 7.77612 1.50397C8.07478 1.9733 8.22412 2.5333 8.22412 3.18397C8.22412 3.38663 8.19212 3.57863 8.12812 3.75997C8.07478 3.9413 8.00545 4.09063 7.92012 4.20797H8.88012V5.39197H0.000117242ZM4.33612 11.808C3.62145 11.808 2.99212 11.6906 2.44812 11.456C1.91478 11.2106 1.49878 10.8693 1.20012 10.432C0.901451 9.98397 0.752117 9.4613 0.752117 8.86397C0.752117 8.65063 0.768117 8.45863 0.800117 8.28797C0.842784 8.1173 0.896117 7.9733 0.960117 7.85597H0.000117242V6.67197H8.88012V7.85597H2.46412C2.38945 7.98397 2.32545 8.12263 2.27212 8.27197C2.21878 8.4213 2.19212 8.58663 2.19212 8.76797C2.19212 9.24797 2.37878 9.6533 2.75212 9.98397C3.13612 10.304 3.63745 10.464 4.25612 10.464C4.85345 10.464 5.38145 10.3146 5.84012 10.016C6.30945 9.7173 6.65078 9.3173 6.86412 8.81597L8.44812 8.94397C8.19212 9.81863 7.69612 10.5173 6.96012 11.04C6.22412 11.552 5.34945 11.808 4.33612 11.808Z" fill="#09090B"/>
</svg>
</span></div>
                      </div>
                      <button class="result__submit" v-loading="concludeOffer"
                              v-on:click="selectOffer(offer)"> Оформити </button>
                      <div v-if="showEarnings && offer.earnings" class="result__earnings mt-2 text-center" style="font-size: 13px; color: #6c757d;">
                        Ваш заробіток {{ offer.earnings }} грн ({{ Math.round((offer.earnings / offer.price) * 100) }}%)
                      </div>
                    </div>

                  </div>
                  <!-- Detailed Info Collapse -->
                  <div :id="'brandMore-'+index" class="row details collapse details-article-more">
                    <div class="col-12 p-0">
                      <section class="accident-offers__expanded">
                        <div class="accident-offers__tabs">
                          <div class="accident-offers__tab accident-offers__tab--active">
                            Загальна інформація
                          </div>
                        </div>
                        <div class="accident-offers__expanded-content">
                          <a
                            v-for="item in getGeneralInfoItems(offer)"
                            :key="item.title"
                            :href="item.href"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="accident-offers__info-row"
                          >
                            <span>{{ item.title }}</span>
                            <span class="accident-offers__info-row-arrow">›</span>
                          </a>
                        </div>
                        <div v-if="offer.company && offer.company.descriptionLink" class="accident-offers__product-description">
                          <div class="accident-offers__product-description-label">Опис продукту</div>
                          <div class="accident-offers__product-description-text">{{ offer.company.descriptionLink }}</div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccidentSearchForm from './components/AccidentSearchForm.vue';
import AccidentPolicyInfo from './components/AccidentPolicyInfo.vue';
import { calculateAccident } from '@/api/accidentInsuranceCompany';

export default {
  name: 'AccidentResults',
  components: { AccidentSearchForm, AccidentPolicyInfo },
  data() {
    return {
      offers: [],
      loading: true,
      showEarnings: false,
      concludeOffer: false,
    }
  },
  computed: {
    searchParams() {
      return this.$store.getters.GET_SEARCH_ACCIDENT_PARAMS;
    }
  },
  created() {
    if (!this.searchParams) {
      this.$router.push({ name: 'accidentSearch' });
      return;
    }
    this.fetchOffers();
  },
  methods: {
    async fetchOffers() {
      this.loading = true;
      this.offers = [];
      try {
        const response = await calculateAccident(this.searchParams);
        if (response.data && response.data.data) {
          this.offers = response.data.data;
          this.$nextTick(() => {
            window.$('[data-toggle="tooltip"]').tooltip({ html: true });
          });
        }
      } catch (error) {
        console.error('Error fetching accident offers:', error);
        this.$toast.error('Помилка при отриманні пропозицій');
      } finally {
        this.loading = false;
      }
    },
    handleSearch(params) {
      // Form handled store commit, we just need to refresh results
      this.fetchOffers();
      // Close collapse
      window.$('#searchcollapse').collapse('hide');
    },
    showNetto(offer) {
      let fullPrice = offer.fullPrice ?? offer.price;
      let earnings = offer.earnings ?? 0;
      return (Math.ceil(fullPrice - earnings)).toFixed(2);
    },
    selectOffer(offer) {
      this.concludeOffer = true;
      const isFromProlongation = this.$route.query?.from === 'prolongation';
      const isFromHistory = this.$route.query?.from === 'history';
      const currentFullOrder = this.$store.getters.GET_ACCIDENT_FULL_ORDER;

      if ((isFromProlongation || isFromHistory) && currentFullOrder && (currentFullOrder.payer || currentFullOrder.insured)) {
        this.$store.commit('SET_ACCIDENT_FULL_ORDER', {
          ...currentFullOrder,
          orderId: null,
          offerInfo: offer,
          offerId: offer.offerId,
          price: offer.price,
          fullPrice: offer.price,
          statusId: 1,
          status: 'draft',
          isOrderCreated: false,
        });
      } else {
        this.$store.commit('CLEAR_ACCIDENT_FULL_ORDER');
      }
      this.$store.commit('SET_ACCIDENT_INFO_OFFER', offer);
      // Logic for next step (step 3: fill information)
      this.$router.push({
        name: 'accidentSteps',
        query: isFromProlongation ? { from: 'prolongation' } : (isFromHistory ? { from: 'history' } : {})
      });
      this.concludeOffer = false;
    },
    getGeneralInfoItems(offer) {
      if (!offer) return [];
      const company = offer.company || {};
      return [
        { title: 'Інформація про страховий продукт', href: company.docProduct || offer.docProduct },
        { title: 'Інформація про страхову компанію', href: company.docCompany || offer.docCompany },
        { title: 'Інформація про страхового посередника', href: company.docAgent || offer.docAgent },
        { title: 'Інформація про загальні умови страхового продукту', href: company.docZusp || offer.docZusp },
      ].filter((item) => !!item.href);
    }
  }
}
</script>

<style lang="scss" scoped>
.params-search {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  margin-bottom: 24px;
}
.params-search__toggler {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  cursor: pointer;
  color: #333;
  text-decoration: none;
}
.params-search__toggler svg {
  transition: transform 0.2s;
}
.params-search__toggler.collapsed svg {
  transform: rotate(-90deg);
}

.osago-offers__earnings {
    margin-bottom: 15px;
    display: flex;
    justify-content: flex-end;
    @media (max-width: 992px) {
        position: static !important;
        margin-bottom: 0;
        right: auto;
        bottom: auto;
    }
}
.osago-offers__earnings button {
    background: none;
    border: none;
    color: #009BEB;
    font-size: 14px;
    cursor: pointer;
}
/* Ensure logo size is consistent */
.result__logo img {
  max-width: 120px;
  max-height: 60px;
  object-fit: contain;
}

.details-article-more {
  padding: 20px;
}

.accident-offers {
  &__expanded {
    width: 100%;
    padding: 20px;
    background: #ffffff;
    border-top: 1px solid #cbd5e1;
  }

  &__tabs {
    display: flex;
    justify-content: center;
    gap: 40px;
    margin-bottom: 20px;
  }

  &__tab {
    position: relative;
    border: 0;
    background: transparent;
    color: #18181b;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    padding: 0 0 8px;
    cursor: pointer;

    &--active::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 2px;
      border-radius: 999px;
      background: #fb923c;
    }
  }

  &__expanded-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__info-row {
    min-height: 40px;
    padding: 10px 14px;
    border: 0;
    border-radius: 8px;
    background: #f8fafc;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    color: #3f3f46;
    font-size: 14px;
    cursor: pointer;
    text-decoration: none;
    transition: background-color 0.2s ease;

    &:hover {
      background: #f1f5f9;
      text-decoration: none;
      color: #3f3f46;
    }
  }

  &__info-row-arrow {
    color: #0a77ff;
    font-size: 20px;
    line-height: 1;
  }

  &__product-description {
    margin-top: 16px;
    padding: 16px 18px;
    border: 1px solid #dbeafe;
    border-radius: 10px;
    background: linear-gradient(180deg, #f8fbff 0%, #f0f7ff 100%);
  }

  &__product-description-label {
    margin-bottom: 6px;
    color: #0f172a;
    font-size: 15px;
    line-height: 1.4;
    font-weight: 600;
  }

  &__product-description-text {
    color: #475569;
    font-size: 14px;
    line-height: 1.5;
  }
}
</style>
